module.exports = __webpack_public_path__ + "img/ander2.dc068781.jpg";